module.exports = __webpack_public_path__ + "images/emoji_312d311f33a38dee3b8bd0463cf287cee.svg";